import { ActionIcon, Menu } from "@mantine/core";
import { IconMailSearch } from "@tabler/icons-react";
import { useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useIsOnline } from "src/hooks";
import { MEDLBID } from "../../../utils";

interface Props {
  hamburger?: boolean;
}

const SearchButton = ({ hamburger }: Props) => {
  const navigate = useNavigate();
  const { logbookId, idType } = useParams();
  const isOnline = useIsOnline();

  const handleSearch = useCallback(
    () => navigate(`/search/${logbookId}?type=${idType}`),
    [idType, logbookId, navigate],
  );

  if (!logbookId || !idType || !isOnline || logbookId !== MEDLBID) {
    return <></>;
  }

  if (hamburger) {
    return (
      <Menu.Item onClick={handleSearch} leftSection={<IconMailSearch size={20} />}>
        Search
      </Menu.Item>
    );
  }

  return (
    <ActionIcon
      onClick={handleSearch}
      color="main"
      ml={15}
      size="lg"
      variant="outline">
      <IconMailSearch />
    </ActionIcon>
  );
};

export default SearchButton;
